import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingPages = {
  name: "getTrackingPages" as const,
  input: z.object({}),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string().nullable(),
      isDefault: z.boolean(),
    }),
  ),
};
